/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_UnlimitedInputs */

const en_mk_mx_unlimited = /** @type {(inputs: Mk_Mx_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited`)
};

const id_mk_mx_unlimited = /** @type {(inputs: Mk_Mx_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanpa batas`)
};

/**
* | output |
* | --- |
* | "Unlimited" |
*
* @param {Mk_Mx_UnlimitedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_unlimited = /** @type {((inputs?: Mk_Mx_UnlimitedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_UnlimitedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_unlimited(inputs)
	return en_mk_mx_unlimited(inputs)
});